// ©2024 Austin App House. All rights reserved.
import React from 'react';
import AvailableToApproveWorkOrder from './AvailableToApproveWorkOrder';
import NotEnoughFunds from './NotEnoughFunds';
import WorkOrderHaveExpenses from './WorkOrderHaveExpenses';

const Content = ({
  contentType,
  fundsInfo,
}) => {
  switch (contentType) {
    case 'approveAvailable':
      return <AvailableToApproveWorkOrder fundsInfo={fundsInfo} />;
    case 'notEnoughFunds':
      return <NotEnoughFunds fundsInfo={fundsInfo} />;
    case 'workOrderHaveExpenses':
      return <WorkOrderHaveExpenses fundsInfo={fundsInfo} />;
    default:
      return (
        <div className="flex-box flex-center full-width">
          <h6>Something goes wrong!</h6>
          <label>Try again later.</label>
        </div>
      );
  }
};

export default Content;
